<template>
  <div style="width:90%">
       <div class="container_body">
            <header class="header_nav">
                <el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
                    <el-form-item label="公司名称" class='tiny'>
                        <el-input style="width:300px;" v-model="orderInfo.expressName" placeholder="请输入物流公司名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <template>
                            <el-button type="primary" @click="search">查询</el-button>
                            <el-button type="primary" @click="empty">清空</el-button>
                        </template>
                    </el-form-item>
                 <el-button type="primary"  @click="addCarousel">新增</el-button>
                </el-form>

            </header>    
        
    </div>
          <!-- 列表展示 -->
      <el-table :data="expressList" stripe style="width: 100%">
        <el-table-column type="index"  align="center" width="90" label="#">
          </el-table-column>
         
            <el-table-column prop="expressName" label="公司名称"  align="center" width="" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="code" label="编号"  align="center" width="" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="letter" label="首字母"  align="center" width="" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="url" label="公司网址"  align="center" width="" :show-overflow-tooltip="true">
            </el-table-column>
             <el-table-column
               prop="isEnable"
                label="是否启用"
                 align="center"
                 :show-overflow-tooltip="true">
   
      <template slot-scope="scope">
        <span v-if="scope.row.isEnable==true">否</span>
        <span v-if="scope.row.isEnable==false">是</span>

      </template>
    </el-table-column>
            <el-table-column prop="createTime" label="创建时间"  align="center" width="" :show-overflow-tooltip="true">
            </el-table-column>
                <el-table-column
      prop=""
      label="操作"
      
      align="center"
      :show-overflow-tooltip="true"
    >
      <template slot-scope="scope">
        <el-button
          size="small"
          type="text"
          @click="editialogVisible(scope.row.id)"
          >编辑</el-button
        >
        <el-button size="small" type="text" @click="toDelete(scope.row.id)"
          >删除</el-button
        >
        　　　　
      </template>
    </el-table-column>
      </el-table>
      <!-- 分页 -->
        <el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum" @current-change="pageChange"
		 layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total" @size-change="handleSizeChange">
	</el-pagination>
    <!-- 新增 -->
    <el-dialog :visible.sync="dialogVisibleSwiper" title="添加物流公司" @close="addDialogClose"  :close-on-click-modal="false">
        <div style="text-align: center">
            <el-form v-model="storeGoodsInfo" >
                <el-form-item label="编号" >
			<el-input type="text" style="width: 300px; margin-left:25px ;" v-model="storeGoodsInfo.code" auto-complete="off" placeholder="请输入编号" />
		</el-form-item>
            <el-form-item label="公司名称" >
			<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.expressName" auto-complete="off" placeholder="请输入公司名称" />
		</el-form-item>
        
        <el-form-item label="公司网址" >
			<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.url" auto-complete="off" placeholder="请输入公司网址" />
		</el-form-item>
        <el-form-item label="是否启用" class="redItem">
			<el-switch v-model="storeGoodsInfo.isEnable" :active-value="true" :inactive-value="false" class="switchss">
			</el-switch>
		</el-form-item>
        <el-button type="primary"  @click="submit">提交</el-button>

            </el-form>    
        </div>
    </el-dialog>   
       <!-- 编辑修改 -->
    <el-dialog :visible.sync="dialogVisibleSwipers" title="编辑修改" @close="addDialogClose"  :close-on-click-modal="false">
        <div style="text-align: center">
            <el-form v-model="storeGoodsInfo" >
                <el-form-item label="编号" >
			<el-input type="text" style="width: 300px; margin-left:25px ;" v-model="storeGoodsInfo.code" auto-complete="off" placeholder="请输入编号" />
		</el-form-item>
            <el-form-item label="公司名称" >
			<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.expressName" auto-complete="off" placeholder="请输入公司名称" />
		</el-form-item>
        
        <el-form-item label="公司网址" >
			<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.url" auto-complete="off" placeholder="请输入公司网址" />
		</el-form-item>
        <el-form-item label="是否启用" class="redItem">
			<el-switch v-model="storeGoodsInfo.isEnable" :active-value="true" :inactive-value="false" class="switchss">
			</el-switch>
		</el-form-item>
        <el-button type="primary"  @click="submitClick">提交</el-button>

            </el-form>    
        </div>
    </el-dialog>  
  </div>
</template>

<script>
export default {
data(){
    return{
        page: {
        pageNum: 1,
        pageSize: 10,
      },
      expressList:[],
      orderInfo:{},
      storeGoodsInfo:{},
      dialogVisibleSwiper:false,
      dialogVisibleSwipers:false

    }
},
methods:{
    search(){//查询
     this.page.pageNum = 1;
      this.sysExpressList()

    },
     empty(){//清空
    this.orderInfo={}

    },
     addDialogClose(){
      // console.log('aaa')

      this.storeGoodsInfo={}
    },
    sysExpressList(){
        let data={
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
       expressName:this.orderInfo.expressName
    }
    this.$api.sysExpressList(data).then((res)=>{
        // console.log(res)
        if(res.state=='success'){
            this.expressList=res.data.list
            this.sliderlist=res.data
        }
    })

    },
    // 新增
    addCarousel(){
        this.dialogVisibleSwiper=true

    },
   
    // 提交
    submit(){
        let data=this.storeGoodsInfo
        // console.log(data)
        this.$api.addExpressList(data).then((res)=>{
            // console.log(res)
            if(res.state=='success'){
                this.$message({
							message: res.message,
							type: 'success'
                        });
            this.sysExpressList()
            this.dialogVisibleSwiper=false
            this.storeGoodsInfo={}
            }else {
						this.$message.error(res.message);
					}
        })

    },
    
    // 编辑
    editialogVisible(e){
        this.$api.findSliderInfo(e).then((res)=>{
           if(res.state=='success'){
               this.storeGoodsInfo=res.data
               this.storeGoodsInfo.isEnable=!res.data.isEnable
                this.dialogVisibleSwipers=true
           }
        })

    },
    // 编辑修改提交
    submitClick(){
        let data=this.storeGoodsInfo
        this.$api.editExpressList(data).then((res)=>{
            // console.log(res)
            if(res.state=='success'){
                this.$message({
					message: res.message,
					type: 'success'
                 });
                 this.dialogVisibleSwipers=false
                 this.sysExpressList();
                 this.storeGoodsInfo={}
            }else {
				this.$message.error(res.message);
			}
        })

    },
    // 删除
    toDelete(e){
  // console.log(e)
      var str = "此操作将删除该轮播, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
          // console.log(e)
					this.$api.delSliderInfo(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.sysExpressList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

    },
     pageChange(data) {
		this.page.pageNum = data
		this.sysExpressList();
			},
	handleSizeChange(val) {
		this.page.pageSize = val
		this.sysExpressList()
      },
    },
   
    


created(){
    this.sysExpressList()
}
}
</script>

<style>

</style>